import React from "react"
import { FolderPlusIcon, TrashIcon, ArrowUpTrayIcon, DocumentTextIcon, ArrowTopRightOnSquareIcon, PencilSquareIcon } from "@heroicons/react/24/outline"
import { Button } from '../../shadcnComponents/ui/button';
import { useLocation } from "react-router-dom"

export function ActionBar(props) {
    const location = useLocation()

    if (location.pathname == '/myFiles') {
        return (
            <div id='action-bar' className="flex flex-row flex-wrap items-center justify-start py-2 gap-1 mt-2">
                <Button variant="ghost" onClick={() => { props.revealNewFolderMenu() }} >
                    <FolderPlusIcon className="size-5" />
                    <div>Nέος φάκελος</div>
                </Button>
                <Button variant="ghost" onClick={() => { props.revealFileUploadMenu() }}>
                    <ArrowUpTrayIcon className="size-5" />
                    <div>Προσθήκη αρχείου</div>
                </Button>
                <Button variant="ghost" onClick={() => { props.transcribeFile() }}>
                    <DocumentTextIcon className="size-5" />
                    <div>Απομαγνητοφώνηση</div>
                </Button>
                <Button variant="ghost" onClick={() => { props.triggerMoveMenu() }}>
                    <ArrowTopRightOnSquareIcon className="size-5" />
                    <div>Μετακίνηση</div>
                </Button>
                <Button variant="ghost" onClick={() => { props.triggerRenameMenu() }}>
                    <PencilSquareIcon className="size-5" />
                    <div>Μετονομασία</div>
                </Button>
                <Button variant="ghost" onClick={() => { props.revealDeleteElementMenu() }}>
                    <TrashIcon className="size-5" />
                    <div>Διαγραφή</div>
                </Button>
            </div>
        )
    } else {
        return (
            <div id='action-bar' className="flex flex-row flex-wrap items-center justify-start py-2 gap-1 mt-2">
                <Button variant="ghost" onClick={() => { props.transcribeFile() }}>
                    <DocumentTextIcon className="size-5" />
                    <div>Απομαγνητοφώνηση</div>
                </Button>
                <Button variant="ghost" onClick={() => { props.revealDeleteElementMenu() }}>
                    <TrashIcon className="size-5" />
                    <div>Διαγραφή</div>
                </Button>
            </div>
        )
    }
}


export default ActionBar